import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const filterOptions = createFilterOptions({
  trim: true,
});

const CustomAutoComplete = ({...props}) => (
  <Autocomplete
    {...props}
    filterOptions={filterOptions}
    componentsProps={{
      paper: {
        sx: {
          boxShadow: 3,
        }
      }
    }}
  />
);

export default CustomAutoComplete;